import { useState, useEffect } from 'react';
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';
import { setManualOfflineMode } from '../../utils/helper';

/**
 * Shared offline-toggle behaviour.
 *
 * Keeps the localStorage-backed manual offline flag and its context mirror in
 * sync, and tracks the browser's real connectivity so consumers can show the
 * *effective* offline state.
 */
export function useOfflineToggle() {
  const { isManualOffline, setIsManualOffline } = useDocument();
  const [isBrowserOnline, setIsBrowserOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsBrowserOnline(true);
    const handleOffline = () => setIsBrowserOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  const offline = isManualOffline || !isBrowserOnline;

  const toggle = () => {
    // No network means we can't go back online — leave the manual intent alone.
    if (!isBrowserOnline) return;
    const next = !isManualOffline;
    setManualOfflineMode(next);
    setIsManualOffline(next);
    // Let listeners react the same way whichever route connectivity returned by.
    if (!next && window.navigator.onLine) {
      window.dispatchEvent(new Event('online'));
    }
  };

  return { offline, isBrowserOnline, isManualOffline, toggle };
}

export default useOfflineToggle;
